import { useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"

interface ProfessionalTutorialVideoModalProps {
  triggerSlot?: React.ReactNode
}

export function ProfessionalTutorialVideoModal({
  triggerSlot,
}: ProfessionalTutorialVideoModalProps) {
  const [open, setOpen] = useState(false)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {triggerSlot ? <DialogTrigger asChild>{triggerSlot}</DialogTrigger> : null}
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Tutorial</DialogTitle>
        </DialogHeader>
        <div className="relative w-full" style={{ paddingBottom: "64.55%" }}>
          <iframe
            src="https://www.loom.com/embed/62ac2dcc73d5472b9bcd64c187348ca3"
            frameBorder="0"
            allowFullScreen
            className="absolute inset-0 w-full h-full rounded-md"
            title="Professional tutorial video"
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
